import { render, staticRenderFns } from "./NumberType.vue?vue&type=template&id=7890e7d8&"
import script from "./NumberType.vue?vue&type=script&lang=js&"
export * from "./NumberType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7890e7d8')) {
      api.createRecord('7890e7d8', component.options)
    } else {
      api.reload('7890e7d8', component.options)
    }
    module.hot.accept("./NumberType.vue?vue&type=template&id=7890e7d8&", function () {
      api.rerender('7890e7d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/CustomField/types/NumberType.vue"
export default component.exports